
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Editor } from 'tiptap'
import { CorrectAnswerOVO, ExplanationIVO } from '@/views/biz/omr/vo/Omr.vo'
import { FileMstVO } from '@/views/bizcommon/file/vo/FileVO'
import { TiptapVuetify,
        Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, 
        OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, 
        Image } from 'tiptap-vuetify'
import axios from 'axios'
import CommonUtils from '@/common-utils'

@Component({
  components: {TiptapVuetify}
})
export default class ExplanationFormDialog extends Vue {
  @Prop() explanation !: CorrectAnswerOVO;

  editor: Editor = null as Editor;
  currentContentJson;
  loading = false;
  validForm = false;
  explanationIVO = {} as ExplanationIVO;
  uploadFile: FileMstVO = {} as FileMstVO;

  extensions = [
    History,
    Blockquote,
    Link,
    Underline,
    Strike,
    Italic,
    ListItem,
    BulletList,
    OrderedList,
    [Heading, {
      options: {
        levels: [1, 2, 3]
      }
    }],
    Bold,
    Code,
    HorizontalRule,
    Paragraph,
    HardBreak,
    Image
  ];

  contentRules = [
    (v: string) => !!v || '내용을 입력해주세요.',
  ];

  async closeDialog() {
    const res =  await this.$confirm('풀이 작성을 취소 하실건가요?', CommonUtils.baseConfirmOption);
    if(res) {
      this.explanationIVO = {} as ExplanationIVO;
      this.$store.dispatch(`explanationForm/closeModal`, {name: 'explanationForm'});
    }
  }

  // 저장
  async saveExplanationForm() {
    if(this.validForm && this.explanationIVO.exContent) {
      this.loading = true;
      const res =  await this.$confirm('저장 하시겠어요?', CommonUtils.baseConfirmOption);

      this.explanationIVO.caNo = this.explanation.caNo;
      this.explanationIVO.exQstNo = this.explanation.rowNum*1;

      if(res) {
        axios.post('omr/explanation', this.explanationIVO)
        .then(r => {
          this.explanationIVO = {} as ExplanationIVO;
          this.$store.dispatch(`explanationForm/closeModal`, {name: 'explanationForm'});
        })
      }
      return this.loading = false;
    }
    this.validForm = false;
  }

  // 이미지 선택
  selectPhoto(): void {
    (this.$refs.explanationFile as HTMLElement).click()
  }

  // 이미지 업로드
  async changeExplanationPhoto(e) {
    const formData = new FormData();
    for(const file of e.target.files) {
      if(!file.type.match(e.target.accept)) {
        alert('이미지 파일만 가능해요');
        return;
      }

      formData.append("files", file);
    }
    formData.append("fileType", "explanation");

    await axios.post('/common/upload-files', formData, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(r => {
      const result = r.data;

      for(const file of result) {
        const uploadFile = file.file;
        const img = {
          constent: 'inline*',
          type: 'image',
          attrs: {
            src: uploadFile.fmUrl,
            alt: file.fileName,
            title: file.fileOrgNm
          }
        }

        this.currentContentJson = this.editor.getJSON();

        this.currentContentJson.content.push(img)
        this.editor.setContent(this.currentContentJson, true);
      }

    })
  }

  // 에디터 초기화시 초기 내용 저장
  // 사진을 추가한다거나 추 후, setContent함수를 이용해야 할 때 기본값이 없을 경우 에러남
  async onInit(editor) {
    this.editor = await editor.editor;
    this.editor.focus;
    this.currentContentJson = this.editor.getJSON();
  }

  @Watch('$store.state.explanationForm.opened', {deep: true})
  editorInit(): void {
    if(this.$store.state.explanationForm.opened == false) return; 

    axios.get(`omr/explanation/${this.explanation.caNo}`)
    .then(r=>{
      if(r.data && this.editor) {
        this.explanationIVO = r.data;
        this.editor.setContent(r.data.exContent)
        this.validForm = true;
      }
    })
  }

  created(): void {
    this.currentContentJson || (this.currentContentJson = {content: []})
  }
}
